"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimTypeCodeFrenchMapping = exports.ClaimTypeCodeEnglishMapping = exports.ClaimTypeCodeFrench = exports.ClaimTypeCodeEnglish = exports.ClaimTypeCode = void 0;
var ClaimTypeCode;
(function (ClaimTypeCode) {
    ClaimTypeCode["TitleTransfer"] = "01";
    ClaimTypeCode["AssignmentOfMortgage"] = "02";
    ClaimTypeCode["DeficiencySale"] = "03";
    ClaimTypeCode["EnhancedClaimService"] = "04";
    ClaimTypeCode["WalkAway"] = "05";
})(ClaimTypeCode = exports.ClaimTypeCode || (exports.ClaimTypeCode = {}));
exports.ClaimTypeCodeEnglish = {
    'Assignment of Mortgage': [ClaimTypeCode.AssignmentOfMortgage],
    'Deficiency Sale': [ClaimTypeCode.DeficiencySale],
    'Enhanced Claim Service': [ClaimTypeCode.EnhancedClaimService],
    'Title Transfer': [ClaimTypeCode.TitleTransfer],
    'Walk Away': [ClaimTypeCode.WalkAway],
};
exports.ClaimTypeCodeFrench = {
    Abandon: [ClaimTypeCode.WalkAway],
    'Cession d’hypothèque': [ClaimTypeCode.AssignmentOfMortgage],
    'Service amélioré des demandes de règlement': [ClaimTypeCode.EnhancedClaimService],
    'Transfert de titre': [ClaimTypeCode.TitleTransfer],
    'Vente assortie du déficit résiduel': [ClaimTypeCode.DeficiencySale],
};
exports.ClaimTypeCodeEnglishMapping = (_a = {},
    _a[ClaimTypeCode.TitleTransfer] = 'Title Transfer',
    _a[ClaimTypeCode.AssignmentOfMortgage] = 'Assignment of Mortgage',
    _a[ClaimTypeCode.DeficiencySale] = 'Deficiency Sale',
    _a[ClaimTypeCode.EnhancedClaimService] = 'Enhanced Claim Service',
    _a[ClaimTypeCode.WalkAway] = 'Walk Away',
    _a);
exports.ClaimTypeCodeFrenchMapping = (_b = {},
    _b[ClaimTypeCode.TitleTransfer] = 'Transfert de titre',
    _b[ClaimTypeCode.AssignmentOfMortgage] = 'Cession d’hypothèque',
    _b[ClaimTypeCode.DeficiencySale] = 'Vente assortie du déficit résiduel',
    _b[ClaimTypeCode.EnhancedClaimService] = 'Service amélioré des demandes de règlement',
    _b[ClaimTypeCode.WalkAway] = 'Abandon',
    _b);
